<template>
  <div class="h-100">
    <div class="row h-100">
      <div class="col flex-1 d-flex flex-column justify-content-bottom mt-md-3 mt-sm-3" v-show="member.contacts.length > 0">
        <div class="row">
          <div class="col-lg" v-for="contact in contacts" :key="contact.id">
            <div class="name">{{name(contact)}}</div>
            <div class="job">{{contact.jobTitle}}</div>
            <div class="phone" v-show="phone(contact)"><a :href="phoneLink(contact)"><i class="fa fa-fw fa-phone-square" aria-hidden="true"></i> {{phone(contact)}}</a></div>
          </div>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
  export default {
    props: {
      member: {
        type: Object
      },
    },
    computed: {
      contacts() {
        if(!this.member || !this.member.contacts.length > 0) {
          return []
        }
        // first contact
        return [ this.member.contacts[0] ] 
      }
    },
    methods: {
      name(contact) {
        return (contact.firstName + ' ' + contact.surname).trim()
      },
      phone(contact) {
        if(contact.phone && contact.extension) {
          return contact.phone + ' x ' + contact.extension
        } 
        if(contact.phone) {
          return contact.phone
        }
        return ''
      },
      phoneLink(contact) {
        if(contact.phone && contact.extension) {
          return 'tel:' + contact.phone + 'p' + contact.extension
        } 
        if(contact.phone) {
          return 'tel:' + contact.phone
        }
        return '#'
      }
    },
  }
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #2c3e50;
}
a:hover {
  transition: color 1s ease
}
.name {
  font-weight: bold;
}
.phone {
  font-size: 0.9em;
}
i {
  color: #ccc;
}
a:hover i {
  color: #888;
  transition: color 1s ease
}
</style>